import Typography from '@mui/material/Typography'
import { Box, useMediaQuery, useTheme } from '@mui/material'
import InviteUsersForm from '../../../../components/forms/entrepriseProfile/inviteUsersForm'

interface Props {
  handleClose: () => void
  handleOpenSendInvitation: () => void
}

export default function BodyModalInviteUsers({
  handleClose,
  handleOpenSendInvitation,
}: Props) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        mt: isMobile ? '8px' : '16px',
      }}
    >
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <Typography sx={{ 
          mb: isMobile ? '24px!important' : '40px!important', 
          width: isMobile ? '100%' : '90%',
          fontSize: isMobile ? '14px' : undefined,
          lineHeight: isMobile ? '20px' : undefined
        }}>
          Les utilisateurs recevront une invitation par courriel à se joindre à votre organisation sur
          ACQ.org et à se créer des accès. Ils apparaîtront « En attente » dans la liste tant qu'ils
          n'auront pas rempli leur inscription. Si aucun rôle est attribué, le rôle attribué par
          défaut sera « Utilisateur ». Il sera possible de le changer par la suite.
        </Typography>
        <InviteUsersForm
          handleClose={handleClose}
          handleOpenSendInvitation={handleOpenSendInvitation}
        />
      </Box>
    </Box>
  )
}
